/**
 * An array of timeline option objects used for selecting time intervals.
 * Each option contains:
 * - value: The internal value representing the interval (e.g., "Monthly", "Annual").
 * - label: The user-friendly label for display in UI (e.g., "Per Month", "Per Annum").
 * - display: A short abbreviation for the interval (e.g., "Pm" for per month, "Pa" for per annum).
 *
 * @type {Array<{ value: string, label: string, display: string }>}
 */
const TimelineOptions = [
  { value: "Monthly", label: "Per Month",display:"Pm" },
  { value: "Annual", label: "Per Annum", display: "Pa" },
];

export default TimelineOptions;
